import React from 'react';
import { Route } from 'react-router-dom';
import { NoRootAccess, RouteWrapper } from './components';
import { AuthResponse } from './components/Authentication/';
import { ExternalAuthResponse } from './components/Authentication';
import { LoginContainer } from './components/Authentication/Login';
import { GraphAuth } from './components/Authentication/Graph';
import { ConnectedConfigContainer } from './components/Configuration/Config';
import { ConnectedTabContent } from './components/FrameContent';
import { TabRemoval } from './components/TabRemoval';
import { withAuthentication, withErrorHandler } from './context';

export const routes = (
  <RouteWrapper>
    <Route exact path='/' component={NoRootAccess} />
    <Route path='/login' component={LoginContainer} />
    <Route path='/authenticationReply' component={AuthResponse} />
    <Route
      path='/externalAuthenticationReply'
      component={ExternalAuthResponse}
    />
    <Route path='/authorizeGraph' component={GraphAuth} />

    <Route
      path='/team-tab-config'
      component={withErrorHandler(withAuthentication(ConnectedConfigContainer))}
    />
    <Route
      path='/tab-content/:option'
      component={withErrorHandler(withAuthentication(ConnectedTabContent))}
    />
    <Route
      path='/team-tab-removal'
      component={withErrorHandler(withAuthentication(TabRemoval))}
    />
  </RouteWrapper>
);
